<template>
    <td v-if="renderByProperty()" class="editor-content">
        <input class="form-control editor-form" type="number" v-model="selectedComponent.width"/>
    </td>
    <td v-else class="editor-content">
        <input class="form-control editor-form" type="number" v-model="selectedComponent.height"/>
    </td>
</template>

<script>
    export default {
        name: 'ImageSizeStyle',
        props: ['selectedComponent', 'property'],
        data () {
            return {
                model: webase.model
            }
        },
        methods: {
            renderByProperty() {
                return this.property === 'width'
            }
        }
    }
</script>
